import WX from 'weixin-jsapi'
import Http from '../../api/CommonHttp';
const mixin = {
    methods: {
        share(url){
            Http.post(window.__config_env.getweixin,{'url':url.split('#')[0]}).then((res) =>{
                console.log(res)
                //微信JSSDK
                WX.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.AppId, // 必填，公众号的唯一标识
                    timestamp: res.data.Timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.NonceStr, // 必填，生成签名的随机串
                    signature: res.data.Signature, // 必填，签名
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2。详见：http://mp.weixin.qq.com/wiki/7/aaa137b55fb2e0456bf8dd9148dd613f.html
                });
            })
            WX.error(function(res) {
            });
            WX.ready(function() {
                //let link = this.detail.CodeUrl;
                let link = window.__config_env.shareIndexLink;
                let imgUrl = 'https:/jobchat.mmall.com//Content/images/share.jpg';
                //转发到朋友圈
                WX.onMenuShareTimeline({
                    title: '红星美凯龙校招-“星动力”热招',
                    link: link,
                    imgUrl: imgUrl,
                    success: function() {
                        //alert("分享成功~");
                    },
                    cancel: function() {
                        //alert("分享失败");
                    }
                });

                //转发给朋友
                WX.onMenuShareAppMessage({
                    title: '红星美凯龙校招-“星动力”热招',
                    desc: '星鲜青年火热招募ing，小伙伴们都来挑战啦！我看这个职位适合你，分享给你来看看吧！',
                    link: link,
                    imgUrl: imgUrl,
                    type: 'link',
                    dataUrl: '',
                    success: function() {
                        //alert("分享成功~");
                    },
                    cancel: function() {
                        //alert("分享失败");
                    }
                });
            });
        }

    }
}
export default mixin



// WEBPACK FOOTER //
// ./src/modules/index/share.js